import React from "react";
import chrome from "../../../components/common/PageChrome.module.css";
import styles from "./Reports.module.css";

// Shared colour rules for the report tables and bars.
export const UTIL_TARGET = 0.75; // shortcut: fixed 75% billable target until it becomes a company setting.
export const marginTone = (v) => (v == null || v < 0.2 ? "red" : v < 0.35 ? "amber" : "green");
export const utilColor = (v) => (!v ? "#e5e7eb" : v < 0.5 ? "#dc2626" : v < UTIL_TARGET ? "#f59e0b" : "#16a34a");
export const hoursColor = (v) => (v > 1 ? "#dc2626" : v >= 0.9 ? "#f59e0b" : "#185FA5");

export const TwoLine = ({ main, sub, className = "" }) => (
  <span className={className}>
    {main}
    {sub && <span className={chrome.cellSub}>{sub}</span>}
  </span>
);

export const Pill = ({ tone, color, children }) => (
  <span className={`${styles.pill} ${tone ? styles[`pill_${tone}`] : ""}`} style={color ? { background: `${color}22`, color } : undefined}>
    {children}
  </span>
);

// A figure with a thin bar under it, e.g. utilisation or hours used.
export const Meter = ({ text, value, color, className = "" }) => (
  <span className={`${styles.meter} ${className}`}>
    <span>{text}</span>
    <span className={styles.meterTrack}><span style={{ width: `${Math.min(100, Math.max(0, value) * 100)}%`, background: color }} /></span>
  </span>
);
